module.exports = __webpack_public_path__ + "img/xc c.8a8e57cb.png";